import React from 'react'
import { number, oneOf } from 'prop-types'

import * as Styled from './IndicatorIcon.styles'

const iconIcons = {
  1: '-',
  2: 'o',
  3: '+',
}

const IndicatorIcon = ({ type, value, size, ...rest }) => (
  <Styled.IndicatorIcon type={ type } value={ value } size={ size } { ...rest }>
    {'qsr' === type && <span>{iconIcons[value]}</span>}
  </Styled.IndicatorIcon>
)

IndicatorIcon.defaultProps = {
  size: 24,
}

IndicatorIcon.propTypes = {
  type: oneOf(['qsr', 'iqtig']).isRequired,
  value: oneOf([1, 2, 3]),
  size: number,
}

export default IndicatorIcon
